import { render, staticRenderFns } from "./allserviceconfiglist.vue?vue&type=template&id=7b90da6d&scoped=true&"
import script from "./allserviceconfiglist.vue?vue&type=script&lang=js&"
export * from "./allserviceconfiglist.vue?vue&type=script&lang=js&"
import style0 from "./allserviceconfiglist.vue?vue&type=style&index=0&id=7b90da6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b90da6d",
  null
  
)

export default component.exports